<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>권한상품 기본 정보</div>
            </strong>
          </div>
          <div class="table-responsive-sm" v-show="tapType == 'authtap'">
            <table class="table b-table table-striped">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">상품명</label>
                    </td>
                    <td class="">
                      <b-row class="pt-sm-12">
                        <b-col sm="7">
                          <label class="col-form-label" style="width:70%">
                            <b-form-input type="text" v-model="queryParams.p_name" name="p_name" v-validate="'required'" :class="{'is-invalid': errors.has('p_name')}"/>
                          </label>
                          <label class="col-form-label">
                            <span v-show="errors.has('p_name')" :class="{error: errors.has('p_name')}">상품명은 필수 항목 입니다.</span>
                          </label>
                        </b-col>
                      </b-row>
                    </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">구분</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">
                        <b-form-radio-group
                          id="basicCustomType"
                          name="ptype">
                          <div class="custom-control custom-radio custom-control-inline" v-for="(pitem, idx) in productTypeOptions">
                            <input type="radio" :id="'ptypeview'+(idx+1)" name="ptype" class="custom-control-input" v-model="queryParams.p_type" :value="pitem.item_code" checked>
                            <label class="custom-control-label" :for="'ptypeview'+(idx+1)">{{pitem.item_name}}</label>
                          </div>
                        </b-form-radio-group>
                      </label>
                    </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">상품적용기간</label>
                      </td>
                      <td class="">
                        <b-form-radio-group
                          id="basicCustomPeriod"
                          name="period" style="float:left; vertical-align:middle; margin-top:7px">
                          <div class="custom-control custom-radio custom-control-inline" v-for="(pitem, idx) in productPeriodTypeOptions" v-on:click="dateMonthSelect(pitem)">
                            <input type="radio" :id="'periodview'+(idx+1)" name="period" class="custom-control-input" v-model="queryParams.period_code" :value="pitem.item_code" checked>
                            <label class="custom-control-label" :for="'periodview'+(idx+1)">{{pitem.item_name != '0' ? pitem.item_name : '기간설정' }}<span v-show="(idx+1) != productPeriodTypeOptions.length">개월</span></label>
                          </div>
                        </b-form-radio-group>
                        <div style="float:left; vertical-align:middle; width:15%"><b-form-input type="text" name="daterangeinit" :disabled="queryParams.period_code != 'PRDT_PERIOD_1'"/></div>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">다운로드 형식</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">
                        <b-form-radio-group
                          id="basicCustomType"
                          name="ptype">
                          <div class="custom-control custom-radio custom-control-inline" v-for="(pitem, idx) in authDownloadTypeOptions">
                            <input type="radio" :id="'authdownloadview'+(idx+1)" name="authdownload" class="custom-control-input" v-model="queryParams.auth_download_type" :value="pitem.item_code" checked>
                            <label class="custom-control-label" :for="'authdownloadview'+(idx+1)">{{pitem.item_name}}</label>
                          </div>
                        </b-form-radio-group>
                      </label>
                    </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">소비자가</label>
                    </td>
                    <td class="" style="padding:5px; text-indent:3px">
                      <label class="col-form-label">
                        ￦
                      </label>
                      <label class="col-form-label" style="width:35%">
                        <b-form-input type="text" v-model="queryParams.price" name="price" @keyup="numberFormat(queryParams.price)" @blur="numberFormat(queryParams.price)" v-validate="'required'" :class="{'is-invalid': errors.has('price')}"/>
                      </label>
                      <label class="col-form-label">
                        <span v-show="errors.has('price')" :class="{error: errors.has('price')}">금액은 필수로 입력해주세요.</span>
                      </label>
                    </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">노출여부</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">
                        <b-form-radio-group
                          id="basicCustomViewyn"
                          name="viewyn">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="viewY" name="viewyn" class="custom-control-input" v-model="queryParams.view_yn" value="Y" checked>
                            <label class="custom-control-label" for="viewY">노출</label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="viewN" name="viewyn" class="custom-control-input" v-model="queryParams.view_yn" value="N">
                            <label class="custom-control-label" for="viewN">비노출</label>
                          </div>
                        </b-form-radio-group>
                      </label>
                    </td>
                  </tr>
                </tbody>
            </table>
          </div>
          <div class="table-responsive-sm" v-show="tapType == 'dctap'">
            <table class="table b-table table-striped">
                <thead class="" style="background-color:#f1f1f1">
                    <tr style="text-align:center">
                        <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">상품코드</th>
                        <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">상품명</th>
                        <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">구분</th>
                        <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">상품적용기간</th>
                        <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">소비자가</th>
                        <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">등록일</th>
                        <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">최종수정일</th>
                        <th class="" style="vertical-align:middle">노출여부</th>
                    </tr>
                </thead>
                <tbody class="">
                    <!---->
                    <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                        <td class="" style="border-right:1px solid #a4b7c1">{{queryParams.p_code}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{queryParams.p_name}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{queryParams.p_typename}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{queryParams.period_name}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">￦ {{queryParams.price}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{queryParams.reg_date}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{queryParams.upt_date}}</td>
                        <td class="">{{queryParams.view_name}}</td>
                    </tr>
                </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>서비스 권한 설정</strong>
          </div>
          <div style="margin-bottom:20px">
            <b-nav justified tabs>
              <b-nav-item v-bind:active="tapType == 'authtap'" v-on:click="tapType = 'authtap'">권한설정</b-nav-item>
              <b-nav-item v-bind:active="tapType == 'dctap'" v-on:click="userAuthInsert()">할인가설정</b-nav-item>
              <b-nav-item disabled></b-nav-item>
              <b-nav-item disabled></b-nav-item>
            </b-nav>
          </div>
          <div class="table-responsive-sm" v-show="tapType == 'authtap'">
            <table class="table b-table table-striped">
                <thead class="" style="background-color:#f1f1f1">
                    <tr style="text-align:center">
                        <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">메뉴 구분</th>
                        <th class="" style="vertical-align:middle">접근 권한</th>
                    </tr>
                </thead>
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-for="(pauth, idx) in productAuthDepthOptions">
                    <td class="" style="border-right:1px solid #a4b7c1">{{pauth.item_name}}</td>
                    <td class="">
                      <b-form-select :id="'basicSelect_'+pauth.item_code" v-on:change="onCheckAuth($event)"
                        :plain="true"
                        :options="[
                          {text:'열람 가능',value:'Y|'+pauth.item_code},
                          {text:'열람 불가',value:'N|'+pauth.item_code},
                        ]"
                        :value="formtype == 'insert' ? 'Y|'+pauth.item_code : uSvcValueArr[idx].svc_checkyn+'|'+uSvcValueArr[idx].svc_code">
                      </b-form-select>
                    </td>
                  </tr>
                </tbody>
            </table>
          </div>

          <div class="table-responsive-sm" v-show="tapType == 'dctap'">
            <table class="table b-table table-striped">
                <thead class="" style="background-color:#f1f1f1">
                    <tr style="text-align:center">
                        <th class="">할인가격 설정 정보</th>
                    </tr>
                </thead>
            </table>
            <div class="table-responsive-sm">
              <b-table
                striped
                hover
                ref="dctable"
                :fields="dcFieldItems"
                :items="dcItems"
                :busy="dcItems == 0"
                :current-page="currentPage"
                :per-page="perPage">
                <div slot="table-busy" class="text-center my-2">
                  <strong>데이터가 없습니다.</strong>
                </div>
                <template slot="p_price" slot-scope="data">
                  <div style="width:200px">￦ {{Number(data.item.p_price).toLocaleString()}}</div>
                </template>
                <template slot="discount" slot-scope="data">
                  <div style="width:200px" v-show="data.item.complete_yn == 'Y'">
                    <b-form-input type="text" name="discount" placeholder="할인율을 입력해주세요." v-model="discounttext" @keyup="dcPercentResult($event,data.item)" @blur="dcPercentResult($event,data.item)"/>
                  </div>
                  <div style="width:200px" v-show="data.item.complete_yn == 'N'">{{data.item.discount}}</div>
                </template>
                <template slot="dc_price" slot-scope="data">
                  <div style="width:300px" v-show="data.item.complete_yn == 'Y'">
                    <b-form-input type="text" name="dc_price" placeholder="할인율에 따라 자동 계산 됩니다." disabled  style="background-color:#f6f8ff"/>
                  </div>
                  <div style="width:200px" v-show="data.item.complete_yn == 'N'">￦ {{Number(data.item.dc_price).toLocaleString()}}</div>
                </template>
                <template slot="dc_result_price" slot-scope="data">
                  <div style="width:300px" v-show="data.item.complete_yn == 'Y'">
                    <b-form-input type="text" name="dc_result_price" placeholder="할인율에 따라 자동 계산 됩니다." disabled  style="background-color:#f6f8ff"/>
                  </div>
                  <div style="width:200px" v-show="data.item.complete_yn == 'N'">￦ {{Number(data.item.dc_result_price).toLocaleString()}}</div>
                </template>
                <template slot="dc_date" slot-scope="data">
                  <div style="width:200px" v-show="data.item.complete_yn == 'Y'">
                    <b-form-input type="text" name="dcdaterange" />
                  </div>
                  <div style="width:200px" v-show="data.item.complete_yn == 'N'">{{data.item.dc_start_date}} ~ {{data.item.dc_end_date}}</div>
                </template>
                <template slot="complete_yn" slot-scope="data">
                  <div style="width:200px; text-align:center" v-show="data.item.complete_yn == 'Y'">
                    <b-button variant="success" style="color:#ffffff; border-radius:5px; cursor:pointer; width:75px; border:1px solid #187c9f; font-size:13.5px" href="javascript:void(0)" v-on:click="insertDrDcData()" v-show="data.item.savetype == 'Y'"><i class="fa fa-pencil"></i></i> 저장</h5></b-button>
                    <strong style="color:red; margin-top:3px" v-show="data.item.savetype == 'N'">적용중</strong>
                    <b-button variant="dark" style="color:#ffffff; border-radius:5px; cursor:pointer; width:75px; border:1px solid #1f536d; font-size:13.5px" href="javascript:void(0)" v-on:click="drDcdateEnd(data.item)" v-show="data.item.savetype == 'N'"><i class="fa fa-sign-out"></i> 만료</h5></b-button>
                  </div>
                  <div style="width:200px; text-align:center" v-show="data.item.complete_yn == 'N'">
                    <strong style="margin-top:3px">만료</strong>
                  </div>
                </template>
              </b-table>
              <b-col sm="12" class="pt-sm-1">
                <b-row class="pb-sm-2">
                  <b-col sm="1"></b-col>
                  <b-col sm="12" class="my-1">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="dclistRows"
                      :per-page="perPage"
                      align="center"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-col>
            </div>

          </div>
        </b-card>
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4">
                </b-col>
                <b-col md="4">
                  <b-button variant="success" v-on:click="formtype == 'insert' ? insertDrUserAuth() : updateDrUserAuth()" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/product/userauthpermission'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Vue from 'vue';

import datetimepicker from "daterangepicker/daterangepicker.js";
import reportOptModal from './ReportOptModal';
import draggable from "vuedraggable";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import { codeAPI } from '../../common/code.js'

const moment = require("moment");

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  components: {
    reportOptModal,
    draggable,
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      isNew: true,
      opttapCheck:true,
      pkgtapCheck:false,
      formModal:false,
      valueCheck:false,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      discounttext: '',
      auth_param_code: '',
      p_unique_code: '',
      formtype: '',
      oldDayCnt: 0,
      newDayCnt: 0,
      uSvcValueArr: [],
      dcItems: [],
      productAuthDepthOptions: [],
      productTypeOptions: [],
      productPeriodTypeOptions: [],
      authDownloadTypeOptions: [],
      productSvcCheckYNArr: [],
      codeItemDatas: [],
      dcOneItem: {},
      dcOneDiscount: 0,
      newdcOneDiscount: 0,
      dc_sdate: '',
      dc_edate: '',
      row_statustype: '',
      reportOptions: {
        optItems: [],
        pkgItems: [],
      },
      dcDataRow: {},
      betweenDay: 0,
      newFlag:'new',
      pageOptions: [5, 10, 30, 50, 100],
      reportPkgOptDatas: {
        pkgOptList: []
      },
      queryParams: {
        p_type: '',
        period_code: '',
        auth_download_type: '',
        view_yn: 'Y',
        pointminus: 0,
        svcAuthArr: [],
        period_start_date: moment().format('YYYY-MM-DD'),
        period_end_date: moment().add(12, 'months').format('YYYY-MM-DD'),
        reg_date: moment().format('YYYY-MM-DD'),
      },
      dcParams: {
        p_code: '',
        p_price: '',
        discount: '',
        dc_price: 0,
        dc_result_price: 0,
        dc_start_date: moment().format('YYYY-MM-DD'),
        dc_end_date: moment().add(7, 'days').format('YYYY-MM-DD'),
        complete_yn: '',
      },
      optFileYn: false,
      optDatas: {price: 0},
      pkgDatas: {price: 0},
      optList: [],
      pkgList: [],
      // pkgOptList: [],
      optionFileItem: [],
      tapType:'authtap',
      reportSubDepths: [],
      categoryItems: [],
      periodOptions: [],
      pkgExposureOptions: [
        {text: '비노출',value: 0}
      ],
      dcFieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'p_price': {
          'label': '소비자가',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width':'200px'
          }
        }
      }, {
        'discount': {
          'label': '할인율(%)',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width':'200px'
          }
        }
      }, {
        'dc_price': {
          'label': '할인금액',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width':'300px'
          }
        }
      }, {
        'dc_result_price': {
          'label': '할인적용금액',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width':'300px'
          }
        }
      }, {
        'dc_date': {
          'label': '할인기간',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width':'200px'
          }
        }
      }, {
        'complete_yn': {
          'label': '상태',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width':'120px'
          }
        }
      }],
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
      endDate: moment().format('YYYY-MM-DD'),
      startDate: moment().add(-365, 'days').format('YYYY-MM-DD'),
      config: {
        toolbar:[
  				{ name: 'document', items: [ 'Source' ] },
  	      { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
  	      { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'] },
  	      '-',
  	      { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
  	      { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
  	      { name: 'links', items: ['Link', 'Unlink'] },
  	      '/',
  	      { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
  	      { name: 'colors', items: ['TextColor', 'BGColor'] },
				],
        filebrowserImageUploadUrl:'backend/ftpserver/ckeditImageUpload',
        height: 300
      },
      enabled: true,
      previewFileOptions: {
          url: 'backend/ftpserver/dropAndSingleFileUpload',
          autoProcessQueue: false,
          params: {
            files: "file",
            reportType: "ar",
            fileSubPath: "img",
          },
          thumbnailWidth: 150,
          //maxFilesize: 5.0,
          acceptedFiles: '.jpg,.jpeg,.png',
          dictDefaultMessage: "<i class='fa fa-cloud-upload'></i> Drop files here to upload",
      },
      dragging: false,
      isDragging : false,
      file: ''
    }
  },
  computed: {
    dclistRows() {
      return this.dcItems.length;
    }
  },
  watch: {
    discounttext: function(newVal, oldVal){
      this.newdcOneDiscount = newVal;
      if(this.dcOneItem.statustype == 'update'){
        if(newVal != this.dcOneDiscount){
          this.dcOneItem.savetype = "Y";
        }else{
          this.dcOneItem.savetype = "N";
        }
      }
    },
    'dcParams.dc_start_date': function(newVal, oldVal){
      this.oldDayCnt = betweenDayCnt(this.dcDataRow.dc_start_date, this.dcDataRow.dc_end_date);
      this.newDayCnt = betweenDayCnt(this.dcParams.dc_start_date, this.dcParams.dc_end_date);
      this.dayCntCheck(this.oldDayCnt, this.newDayCnt);
    },
    'dcParams.dc_end_date': function(newVal, oldVal){
      this.oldDayCnt = betweenDayCnt(this.dcDataRow.dc_start_date, this.dcDataRow.dc_end_date);
      this.newDayCnt = betweenDayCnt(this.dcParams.dc_start_date, this.dcParams.dc_end_date);
      this.dayCntCheck(this.oldDayCnt, this.newDayCnt);
    },
  },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    var resultDatas = [];
    // 상단 셀렉트 박스 코드 조회
    codeAPI.selectItemCodeList(self,"PRDT_TYPE_2",3,"productTypeOptions"); // 상품구분
    codeAPI.selectItemCodeBackList(self,"PRDT_PERIOD",2,"productPeriodTypeOptions"); // 상품기간
    codeAPI.selectItemCodeList(self,"AUTH_DOWNLOAD_TYPE",2,"authDownloadTypeOptions"); // 상품기간
    codeAPI.selectItemCodeList(self,"PD_AUTH_TYPE",2,"productAuthDepthOptions"); // 계정상품권한구분

    self.auth_param_code = self.$session.get('auth_param_code');
    self.formtype = self.$route.query.status;

    if(self.formtype == 'update'){
      self.queryParams.svcAuthArr = [];
      self.uSvcValueArr = [];
      self.$http.get('/api/select/drProductAuthData?access_token=' + token + '&p_param_code=' + self.auth_param_code)
      .then((result) => {
        self.queryParams = result.data;
        $('input[name="daterangeinit"]').val('');
        self.queryParams.svcAuthArr.forEach(function (el, idx, arr){
          var svcData = {
            svc_code: el.svc_code,
            svc_checkyn: el.svc_checkyn
          };
          self.uSvcValueArr.push(svcData);
        });
        if(self.queryParams.period_code == 'PRDT_PERIOD_1'){
          $(function() {
            $('input[name="daterangeinit"]').daterangepicker({
              opens: 'left',
              "locale": self.calendarLocale,
              "startDate": self.queryParams.period_start_date,
              "endDate": self.queryParams.period_end_date
            }, function(start, end, label) {
              self.queryParams.period_start_date = start.format('YYYY-MM-DD');
              self.queryParams.period_end_date = end.format('YYYY-MM-DD');
            });
          });
          $('input[name="daterangeinit"]').data('daterangepicker').setStartDate(self.queryParams.period_start_date);
    		  $('input[name="daterangeinit"]').data('daterangepicker').setEndDate(self.queryParams.period_end_date);
        }
        self.queryParams.price = Number(self.queryParams.price).toLocaleString();
        self.tapType = 'authtap';
        self.getDcList(self.auth_param_code);
      })
    }

    // ### 코드 정보 불러오기 ###
    // 신규코드를 DB테이블에 저장
    //
    // 최초작성 : 2016.05.31
    // 파라미터 : parentCode
    //  - unit(JSON 형태의 코드 아이템 데이터)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    self.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=RPT_CATE')
    .then((result) => {
      self.productTypeOptions.forEach(function (el, idx, arr){
        if(idx == 0){
          self.queryParams.p_type = el.item_code;
        }
      });
      self.productPeriodTypeOptions.forEach(function (el, idx, arr){
        if(idx == 0){
          self.queryParams.period_code = el.item_code;
        }
      });
      self.authDownloadTypeOptions.forEach(function (el, idx, arr){
        if(idx == 0){
          self.queryParams.auth_download_type = el.item_code;
        }
      });

      if(self.formtype == 'insert'){
        self.queryParams.svcAuthArr = [];
        self.productAuthDepthOptions.forEach(function (el, idx, arr){
          var svcValue = {
            svc_code: el.item_code,
            svc_checkyn: 'Y'
          };
          self.queryParams.svcAuthArr.push(svcValue);
        });
      }else{
        self.productAuthDepthOptions.forEach(function (el, idx, arr){
          var svcValue = {
            svc_code: el.item_code,
            svc_checkyn: 'Y'
          };
        });
      }
    });

    // $(function() {
    //   $('input[name="daterangeinit"]').daterangepicker({
    //     opens: 'left',
    //     "locale": self.calendarLocale,
    //     "startDate": moment().format('YYYY-MM-DD'),
    //     "endDate": moment().add(12, 'months').format('YYYY-MM-DD')
    //   }, function(start, end, label) {
    //     self.queryParams.period_start_date = start.format('YYYY-MM-DD');
    //     self.queryParams.period_end_date = end.format('YYYY-MM-DD');
    //   });
    // });
  },
  methods: {
    // 메소드명 : getDrProductAuthData(val)
    // ### 리포트 데이터 갱신 ###
    // 메소드 저장후 데이터 갱신용으로 사용
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - val(해당 필드의 value 값을 가져옴)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.06.10  황경현   최초작성
    // *************************
    getDrProductAuthData(p_param_code) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.queryParams.svcAuthArr = [];
      self.uSvcValueArr = [];
      self.$http.get('/api/select/drProductAuthData?access_token=' + token + '&p_param_code=' + self.auth_param_code)
      .then((result) => {
        self.queryParams = result.data;
        self.queryParams.svcAuthArr.forEach(function (el, idx, arr){
          var svcData = {
            svc_code: el.svc_code,
            svc_checkyn: el.svc_checkyn
          };
          self.uSvcValueArr.push(svcData);
        });
        self.queryParams.price = Number(self.queryParams.price).toLocaleString();
        $(function() {
          $('input[name="daterangeinit"]').daterangepicker({
            opens: 'left',
            "locale": self.calendarLocale,
            "startDate": moment().format('YYYY-MM-DD'),
            "endDate": moment().add(7, 'days').format('YYYY-MM-DD')
          }, function(start, end, label) {
            self.queryParams.period_start_date = start.format('YYYY-MM-DD');
            self.queryParams.period_end_date = end.format('YYYY-MM-DD');
          });
        });
        if(self.queryParams.period_code == 'PRDT_PERIOD_1'){
          $('input[name="daterangeinit"]').data('daterangepicker').setStartDate(self.queryParams.period_start_date);
    		  $('input[name="daterangeinit"]').data('daterangepicker').setEndDate(self.queryParams.period_end_date);
        }
        self.getDcList(self.auth_param_code);
      })
    },
    // 메소드명 : getDcList(auth_p_code)
    // ### 할인율 리스트 ###
    // 할인율 리스트 조회
    //
    // 최초작성 : 2016.07.05
    // 파라미터 :
    //  - auth_p_code(해당 권한상품 코드)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.05  황경현   최초작성
    // *************************
    getDcList (auth_p_code) {
      var token = sessionStorage.getItem("myToken");
      var self = this;

      self.$http.get('/api/select/drDcList?access_token=' + token + '&p_param_code=' + auth_p_code)
      .then((result) => {
        self.dcItems = result.data;
        var dcListCnt = self.dcItems.length;
        if(dcListCnt == 0){
          var dcInData = {
            rnum: (self.dcItems.length+1),
            p_price: $.trim(self.queryParams.price.replace(/,/g, '')),
            discount: '',
            dc_price: '',
            dc_result_price: '',
            dc_date: '',
            complete_yn: 'Y',
            savetype: 'Y',
            statustype: 'insert'
          }
          self.dcItems.push(dcInData);
        }else{
          var today = new Date();
          var dateString = "";
          self.dcItems.forEach(function (el, idx, arr){
            if(idx == 0){
              dateString = el.dc_end_date;
              self.dcDataRow = el;
            }
          });
          var dateArray = dateString.split("-");
          var dateObj = new Date(dateArray[0], Number(dateArray[1])-1, dateArray[2]);
          self.betweenDay = ((dateObj.getTime() - today.getTime())/1000/60/60/24)+1;
          self.betweenDay = parseInt(self.betweenDay);
          if(self.dcDataRow.complete_yn == 'N'){
            var dcInData = {
              rnum: (self.dcItems.length+1),
              p_price: $.trim(self.queryParams.price.replace(/,/g, '')),
              discount: '',
              dc_price: '',
              dc_result_price: '',
              dc_date: '',
              complete_yn: 'Y',
              savetype: 'Y',
              statustype: 'insert'
            }
            self.dcItems.unshift(dcInData);
          }else{
            self.dcDataRow.savetype = "N";
          }
        }
        self.dcItems.forEach(function (el, idx, arr){
          if(idx == 0){
            self.dcOneItem = el;
            self.dcOneDiscount = el.discount;
            self.dc_sdate = el.dc_start_date;
            self.dc_edate = el.dc_end_date;
            self.row_statustype = el.statustype;
          }
        });

        setTimeout(function(){
          if(self.row_statustype == 'update'){
            self.dcParams.dc_start_date = self.dc_sdate;
            self.dcParams.dc_end_date = self.dc_edate;
          }

          $('input[name="dcdaterange"]').daterangepicker({
            opens: 'left',
            "locale": self.calendarLocale,
            "startDate": moment().format('YYYY-MM-DD'),
            "endDate": moment().add(7, 'days').format('YYYY-MM-DD')
          }, function(start, end, label) {
            self.dcParams.dc_start_date = start.format('YYYY-MM-DD');
            self.dcParams.dc_end_date = end.format('YYYY-MM-DD');
          });

          if(self.dcDataRow.complete_yn != 'N'){
            if(dcListCnt != 0){
              self.discounttext = self.dcDataRow.discount;
              $('input[name="discount"]').val(self.dcDataRow.discount);
              $('input[name="dc_price"]').val("￦ "+Number(self.dcDataRow.dc_price).toLocaleString());
              $('input[name="dc_result_price"]').val("￦ "+Number(self.dcDataRow.dc_result_price).toLocaleString());
              $('input[name="dcdaterange"]').data('daterangepicker').setStartDate(self.dcDataRow.dc_start_date);
              $('input[name="dcdaterange"]').data('daterangepicker').setEndDate(self.dcDataRow.dc_end_date);
            }
          }else{
            self.discounttext = 0;
            $('input[name="discount"]').val("");
            $('input[name="dc_price"]').val("");
            $('input[name="dc_result_price"]').val("");
            $('input[name="dcdaterange"]').data('daterangepicker').setStartDate(moment().format('YYYY-MM-DD'));
            $('input[name="dcdaterange"]').data('daterangepicker').setEndDate(moment().add(7, 'days').format('YYYY-MM-DD'));
          }
        }, 100);
      })
    },
    onCheckAuth(val) {
      var svcCheckYn = val.split('|')[0];
      var svcCode = val.split('|')[1];
      console.log(this.queryParams.svcAuthArr);
      this.queryParams.svcAuthArr.forEach(function (el, idx, arr){
        if(svcCode == el.svc_code){
          if(svcCheckYn != el.svc_checkyn){
            el.svc_checkyn = svcCheckYn;
          }
        }
      });
    },
    dayCntCheck(oldDayCnt, newDayCnt) {
      var self = this;
      if(this.newdcOneDiscount != this.dcOneDiscount){
        this.dcOneItem.savetype = "Y";
      }else{
        if(this.newdcOneDiscount == this.dcOneDiscount){
          if(oldDayCnt == newDayCnt){
            if((this.dcDataRow.dc_start_date == this.dcParams.dc_start_date) && (this.dcDataRow.dc_end_date == this.dcParams.dc_end_date)){
              this.dcItems.forEach(function (el, idx, arr){
                if(idx == 0){
                  el.savetype = "N";
                }
              });
            }else{
              this.dcItems.forEach(function (el, idx, arr){
                if(idx == 0){
                  el.savetype = "Y";
                }
              });
            }
          }else{
            this.dcItems.forEach(function (el, idx, arr){
              if(idx == 0){
                el.savetype = "Y";
              }
            });
          }
        }else{
          this.dcOneItem.savetype = "Y";
        }
      }
      this.$refs.dctable.refresh();
    },
    // 메소드명 : numberFormat(val)
    // ### 숫자입력함수 ###
    // 신규코드를 DB테이블에 저장
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - val(해당 필드의 value 값을 가져옴)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    numberFormat(val) {
      var reg = /[^0-9]/gi;
      if(val.length > 11){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 11){ val = val.substring(0, val.length-1); }
				this.queryParams.price = "0";
      }else{
        this.queryParams.price = Number(val).toLocaleString();
      }
    },
    numberFormatOpt(val) {
      var reg = /[^0-9]/gi;
      if(val.length > 12){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 12){ val = val.substring(0, val.length-1); }
				this.optDatas.price = "0";
      }else{
        this.optDatas.price = Number(val).toLocaleString();
      }
    },
    numberFormatPkg(val) {
      var reg = /[^0-9]/gi;
      if(val.length > 12){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 12){ val = val.substring(0, val.length-1); }
				this.pkgDatas.price = "0";
      }else{
        this.pkgDatas.price = Number(val).toLocaleString();
      }
    },
    // 메소드명 : userAuthInsert()
    // ### 권한 정보 저장후 할인가 탭으로 이동 ###
    // 권한정보를 저정한후 할인가를 설정할수 있게 이동.
    //
    // 최초작성 : 2016.07.02
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.07.02  황경현   최초작성
    // *************************
    userAuthInsert() {
      var self = this;
      console.log(self.formtype);
      if(self.formtype == 'insert'){
        self.$validator.validateAll().then(success => {
          if (success) {
            swal.fire({
              title: '계정상품 할인가설정!',
              html: "할인가 설정시 먼저 기본 계정상품 데이터가 저장되야 합니다.</br>저장하시겠습니까?",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'OK'
            }).then((swalResult) => {
              if (swalResult.value) {
                var token = sessionStorage.getItem("myToken");
                self.queryParams.reg_id = self.$session.get('userId');
                self.queryParams.reg_date = moment().format('YYYY-MM-DD HH:mm:ss');
                self.queryParams.p_parent_code = "PRDT_TYPE_2";
                if(self.queryParams.price != 0){
                    self.queryParams.price = $.trim(self.queryParams.price.replace(/,/g, ''));
                }

                var param = encodeURI(JSON.stringify(self.queryParams));
                var data = new FormData();
                data.append('authObj', param);

                self.$http.post('/api/insert/drUserAuth?access_token='+token, data, null)
                  .then((result) => {
                    var resultPCode = result.data;
                    swal.fire({
                      type: 'success',
                      title: '권한 상품이 등록되었습니다.',
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function() {
                      self.$router.push('/product/userauthpermission/form?status=update');
                      self.formtype = 'update';
                      self.tapType = 'dctap';
                      self.$session.set('auth_param_code', resultPCode);
                      self.auth_param_code = self.$session.get('auth_param_code');
                      self.getDrProductAuthData(resultPCode);
                    });
                })
              }else{
              }
            })
          }
        })
      }else{
        this.tapType = 'dctap';
      }
    },
    dcPercentResult(event,rowdatas){
      var self = this;
      var val = event.target.value;
      var reg = /[^0-9]/gi;
      var priceCnt;
      var dcCnt = '';
      var dcResultCnt = '';
      if(val.length > 3){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 3){
          val = val.substring(0, val.length-1);
          if(val == 0){
            val = "";
          }
        }
				val = "";
      }else{
        if(val > 100){
          val = Number("100").toLocaleString();
        }else{
          val = Number(val).toLocaleString();
        }

        priceCnt = $.trim(rowdatas.p_price.replace(/,/g, ''));
        dcCnt = Math.round(priceCnt - (priceCnt * (1 - val / 100)));
        dcResultCnt = priceCnt - dcCnt;


      }
      if(val == 0){
        self.dcItems.forEach(function (el, idx, arr){
          if(idx == 0){
            el.dc_price = "";
            el.dc_result_price = "";
            $('input[name="dc_price"]').val("");
            $('input[name="dc_result_price"]').val("");
          }
        });
        event.target.value = "";
      }else{
        self.dcItems.forEach(function (el, idx, arr){
          if(idx == 0){
            el.discount = val;
            el.dc_price = Number(dcCnt).toLocaleString();
            el.dc_result_price = Number(dcResultCnt).toLocaleString();
            $('input[name="dc_price"]').val("￦ "+el.dc_price);
            $('input[name="dc_result_price"]').val("￦ "+el.dc_result_price);
          }
        });
        event.target.value = val;
      }
    },
    insertDrDcData() {
      var token = sessionStorage.getItem("myToken");
      var self = this;

      self.dcParams.p_code = self.auth_param_code;
      self.dcParams.complete_yn = "Y";
      self.dcItems.forEach(function (el, idx, arr){
        if(idx == 0){
          self.dcParams.dc_code = el.dc_code;
          self.dcParams.discount = el.discount;
          self.dcParams.dc_price = $.trim(el.dc_price.replace(/,/g, ''));
          self.dcParams.dc_result_price = $.trim(el.dc_result_price.replace(/,/g, ''));
          self.dcParams.statustype = el.statustype;
        }
      });
      self.dcParams.reg_id = self.$session.get('userId');

      var param = encodeURI(JSON.stringify(self.dcParams));
      var data = new FormData();
      data.append('dcObj', param);

      if(self.dcParams.statustype == 'update'){
        self.$http.post('/api/update/drDcData?access_token='+token, data, null)
          .then((result) => {
            swal.fire({
              type: 'success',
              title: '할인가 설정이 수정 되었습니다.',
              showConfirmButton: false,
              timer: 1500
            }).then(function() {
              self.getDcList(self.auth_param_code);
            });
        })
      }else{
        self.$http.post('/api/insert/drDcData?access_token='+token, data, null)
          .then((result) => {
            swal.fire({
              type: 'success',
              title: '할인가 설정이 완료 되었습니다.',
              showConfirmButton: false,
              timer: 1500
            }).then(function() {
              self.getDcList(self.auth_param_code);
            });
        })
      }
    },
    drDcdateEnd(dcData) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.dcParams.p_code = self.auth_param_code;
      self.dcParams.dc_code = dcData.dc_code;
      self.dcParams.reg_id = self.$session.get('userId');

      var param = encodeURI(JSON.stringify(self.dcParams));
      var data = new FormData();
      data.append('dcObj', param);

      console.log(self.dcParams);

      self.$http.post('/api/update/drDcEnd?access_token='+token, data, null)
        .then((result) => {
          swal.fire({
            type: 'success',
            title: '할인가 정보가 만료 되었습니다.',
            showConfirmButton: false,
            timer: 1500
          }).then(function() {
            self.getDcList(self.auth_param_code);
          });
      })
    },
    dateMonthSelect(item) {
      var self = this;
      var addDateCnt = item.item_name;
      setTimeout(function(){
        if(item.item_code != "PRDT_PERIOD_1"){
          // $('input[name="daterangeinit"]').data('daterangepicker').setStartDate(moment().format('YYYY-MM-DD'));
    		  // $('input[name="daterangeinit"]').data('daterangepicker').setEndDate(moment().add(addDateCnt, 'months').format('YYYY-MM-DD'));
          // self.queryParams.preiod_start_date = moment().format('YYYY-MM-DD');
          // self.queryParams.preiod_end_date = moment().add(addDateCnt, 'months').format('YYYY-MM-DD');
        }else{
          $(function() {
            $('input[name="daterangeinit"]').daterangepicker({
              opens: 'left',
              "locale": self.calendarLocale,
              "startDate": moment().format('YYYY-MM-DD'),
              "endDate": moment().add(7, 'days').format('YYYY-MM-DD')
            }, function(start, end, label) {
              self.queryParams.period_start_date = start.format('YYYY-MM-DD');
              self.queryParams.period_end_date = end.format('YYYY-MM-DD');
            });
          });
        }
      }, 100);
    },
    inputChanged(value) {
      console.log(value);
      this.activeNames = value;
    },
    insertDrUserAuth() {
      var self = this;
      self.$validator.validateAll().then(success => {
        if (success) {
          var token = sessionStorage.getItem("myToken");
          self.queryParams.reg_id = self.$session.get('userId');
          self.queryParams.reg_date = moment().format('YYYY-MM-DD HH:mm:ss');
          self.queryParams.p_parent_code = "PRDT_TYPE_2";
          if(self.queryParams.price != 0){
              self.queryParams.price = $.trim(self.queryParams.price.replace(/,/g, ''));
          }
          if(self.queryParams.period_code != 'PRDT_PERIOD_1'){
            self.queryParams.period_start_date = null;
            self.queryParams.period_end_date = null;
          }
          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('authObj', param);

          self.$http.post('/api/insert/drUserAuth?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '권한 상품이 등록되었습니다.',
                showConfirmButton: false,
                timer: 1500
              }).then(function() {
                  window.location = "#/product/userauthpermission";
              });
          })
        }
      })
    },
    // 메소드명 : updateDrUserAuth()
    // ### 보고서 수정 ###
    // 보고서를 각 데이터를 수정한다.
    //
    // 최초작성 : 2016.06.27
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    updateDrUserAuth() {
      var self = this;
      self.$validator.validateAll().then(success => {
        if (success) {
          var token = sessionStorage.getItem("myToken");
          self.queryParams.reg_id = self.$session.get('userId');
          self.queryParams.reg_date = moment().format('YYYY-MM-DD HH:mm:ss');
          self.queryParams.p_parent_code = "PRDT_TYPE_2";
          if(self.queryParams.price != 0){
              self.queryParams.price = $.trim(self.queryParams.price.replace(/,/g, ''));
          }
          if(self.queryParams.period_code != 'PRDT_PERIOD_1'){
            self.queryParams.period_start_date = null;
            self.queryParams.period_end_date = null;
          }
          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('authObj', param);
          if(self.queryParams.period_code != 'PRDT_PERIOD_1'){
            self.queryParams.period_start_date = null;
            self.queryParams.end_date = null;
          }
          self.$http.post('/api/update/drUserAuth?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '권한 상품이 수정되었습니다.',
                showConfirmButton: false,
                timer: 1500
              }).then(function() {
                  window.location = "#/product/userauthpermission";
              });
          })
        }
      })
    },
  }
}

function betweenDayCnt(startday, endday){
  var dayCnt = 0;
  var today = new Date();

  var sdateArray = startday.split("-");
  var sdateObj = new Date(sdateArray[0], Number(sdateArray[1])-1, sdateArray[2]);

  var edateArray = endday.split("-");
  var edateObj = new Date(edateArray[0], Number(edateArray[1])-1, edateArray[2]);

  dayCnt = ((edateObj.getTime() - sdateObj.getTime())/1000/60/60/24)+1;
  dayCnt = parseInt(dayCnt);
  return dayCnt;
}

</script>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}


.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
<style src="daterangepicker/daterangepicker.css">



// WEBPACK FOOTER //
// src/views/product/UserAuthPermissionForm.vue